// extracted by mini-css-extract-plugin
export default {"log_text_element":"log_log_text_element__1fu4q"};